import { Link } from "react-router-dom";

const LinkTextContainer = ({ document, role, title }) => {
  return (
    <>
      {document && (
        <div className="p-2">
          {`${role}: `}
          <Link
            className="hover:text-primary text-primary/85 "
            to={document}
            target="_blank"
          >
            {title}
          </Link>
        </div>
      )}
    </>
  );
};

export default LinkTextContainer;
